import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { DELIVERY_FEATURE } from './delivery-state';
import { reducerProvider, reducerToken } from './reducers';

@NgModule({
  imports: [StoreModule.forFeature(DELIVERY_FEATURE, reducerToken)],
  providers: [reducerProvider],
})
export class CheckoutStoreModule {}
